var map = {
	".": "D4vT",
	"./": "D4vT",
	"./00_post_trade_order": "YI4R",
	"./00_post_trade_order.json": "YI4R",
	"./01_get_commissionRate": "n+yS",
	"./01_get_commissionRate.json": "n+yS",
	"./02_get_leverage": "bFqw",
	"./02_get_leverage.json": "bFqw",
	"./03_post_leverage": "N7P3",
	"./03_post_leverage.json": "N7P3",
	"./04_post_allOpenOrders": "0Lu1",
	"./04_post_allOpenOrders.json": "0Lu1",
	"./05_post_closeAllPositions": "vDcD",
	"./05_post_closeAllPositions.json": "vDcD",
	"./06_get_positions": "+oba",
	"./06_get_positions.json": "+oba",
	"./07_get_balance": "ptJe",
	"./07_get_balance.json": "ptJe",
	"./08_get_forceOrders": "D/10",
	"./08_get_forceOrders.json": "D/10",
	"./09_get_allFillOrders": "f4x/",
	"./09_get_allFillOrders.json": "f4x/",
	"./10_delete_trade_order": "01Ul",
	"./10_delete_trade_order.json": "01Ul",
	"./11_get_all_openOrders": "TzVG",
	"./11_get_all_openOrders.json": "TzVG",
	"./12_get_trade_order": "c76v",
	"./12_get_trade_order.json": "c76v",
	"./14_get_trade_allOrders": "I2ee",
	"./14_get_trade_allOrders.json": "I2ee",
	"./15_get_margin_type": "qPGu",
	"./15_get_margin_type.json": "qPGu",
	"./16_post_margin_type": "LawJ",
	"./16_post_margin_type.json": "LawJ",
	"./17_post_trade_positionMargin": "eN7O",
	"./17_post_trade_positionMargin.json": "eN7O",
	"./index": "D4vT",
	"./index.js": "D4vT"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7m+0";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/cswap/api/trade ^.*$
// module id = 7m+0
// module chunks = 3